import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Transaction } from 'services';
import { ecommerce_manager } from 'utils/constants';
import { Results } from './components';

const TransactionList = props => {
  let { account } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader
        header={account ? `Transactions for ${account.displayname}` : "All Transactions"}
        subheader="Transaction Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Transaction.list}
      title="Transactions"
      name="transactions"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[ecommerce_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", account: account ? account.id : null }}
    />
  );
};

export default TransactionList;
